<template>
    <div class="setting-content--section">
        <div v-if="currentUser.is_accountant">
            <h3><translate>Branding options</translate></h3>
            <hr>
            <p class="branding-description-text"><translate>Your customers currently see their Gekko top menu as shown below. Any modifications to the looks and appearance or information about your company will be seen by your connected customers.</translate></p>
        </div>
        
        <LogoModal v-if="showLogoModal" @close="showLogoModal = false" @logoSetToCompany="onLogoSet" />

        <b-form @submit="onSubmit">
            <b-form-group class="mb-0" id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Logo')" label-for="input-1">
                <div class="company-settings-logo pb-3">
                    <CompanyLogo :wizard="false" :show-name="false" />
                </div>
            </b-form-group>
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Name*')" label-for="input-1" :description="$gettext('Name of your company.')">
                <b-form-input id="input-1" v-model="form.name" required :placeholder="$gettext('Enter company name')" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group v-if="currentUser.is_accountant && !currentCompany.has_accountant" 
                id="input-group-20" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Company color*')" label-for="input-20" :description="$gettext('Color displayed to your customers.')">
                <b-form-input id="input-20" v-model="accountantColor" required type="color" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Type of business entity')" label-for="input-2">
                <b-form-select id="input-2" v-model="form.legal_form" :options="entities" value-field="key" text-field="value" @change="onFormChange"></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-3" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Sector')" label-for="input-3">
                <b-form-select id="input-3" v-model="form.sector" :options="sectors" value-field="key" text-field="value" @change="onFormChange">
                    <template #first>
                        <b-form-select-option :value="null" >---------</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group id="input-group-4" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Company Description')" label-for="input-4">
                <b-form-textarea id="input-4" v-model="form.description" :placeholder="$gettext('Enter a description here...')" rows="3" @change="onFormChange"></b-form-textarea>
            </b-form-group>
            <b-form-group id="input-group-5" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Address')" label-for="input-5">
                <b-form-input id="input-5" v-model="form.address" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-6" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Postal Code')" label-for="input-6">
                <b-form-input id="input-6" v-model="form.postal_code" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-7" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('City')" label-for="input-7">
                <b-form-input id="input-7" v-model="form.city" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-8" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Country') + '*'" label-for="input-8">
                <b-form-select id="input-8" v-model="form.country" :options="countries" @change="onFormChange" :disabled="true" required></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-8-2" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-8-2" class="checkbox-bg-color" v-model="form.show_country_on_invoice" @change="onFormChange" switch><span v-translate>Show country on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group v-if="states" id="input-group-99" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('State')" label-for="input-3">
                <b-form-select id="input-99" v-model="form.administrative_area" :options="states" value-field="key" text-field="value" @change="onFormChange" />
            </b-form-group>
            <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Phone number')" label-for="input-9">
                <b-form-input id="input-9" v-model="form.phone_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group v-show="!currentUser.is_accountant || (currentUser.is_accountant && currentCompany.has_accountant)" id="input-group-10" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-10" class="checkbox-bg-color" v-model="form.phone_number_show_on_invoice" @change="onFormChange" switch><span v-translate>Show phone number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-11" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Email')" label-for="input-11" :description="$gettext('Invoices will be sent from this e-mail address.')">
                <b-form-input id="input-11" v-model="form.email" type="email" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-12" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="coc_label" label-for="input-12" :description="$gettext('Chamber of Commerce registration number.')">
                <b-form-input id="input-12" v-model="form.kvk" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-13" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('VAT identification number')" label-for="input-13">
                <b-form-input id="input-13" v-model="form.btw" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group v-show="!currentUser.is_accountant || (currentUser.is_accountant && currentCompany.has_accountant)" id="input-group-14" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-14" class="checkbox-bg-color" v-model="form.btw_show_on_invoice" @change="onFormChange" switch><span v-translate>Show VAT identification number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-15" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Bank name')" label-for="input-15">
                <b-form-input id="input-15" v-model="form.bank_name" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-16" label-cols-sm="3" label-align-sm="right" content-cols-md="5"  label-class="gk-label-margin" :label="$gettext('Bank account number')" label-for="input-16">
                <b-form-input id="input-16" v-model="form.bank_account_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group v-show="!currentUser.is_accountant || (currentUser.is_accountant && currentCompany.has_accountant)" id="input-group-17" label-cols-sm="3" label-align-sm="right" content-cols-md="5"  label-class="gk-label-margin" :label="$gettext('BIC/Swift')" label-for="input-17">
                <b-form-input id="input-17" v-model="form.companysettings.swift_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group v-show="!currentUser.is_accountant || (currentUser.is_accountant && currentCompany.has_accountant)" id="input-group-18" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-18" class="checkbox-bg-color" v-model="form.companysettings.show_swift_on_invoice" @change="onFormChange" switch><span v-translate>Show BIC/Swift on invoice</span></b-form-checkbox>
            </b-form-group>
            
            <b-form-group id="input-group-24" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Website')" label-for="input-24">
                <b-form-input id="input-24" v-model="form.website" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-25" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-25" class="checkbox-bg-color" v-model="form.website_show_on_invoice" @change="onFormChange" switch><span v-translate>Show website on invoice</span></b-form-checkbox>
            </b-form-group>

            <b-alert class="float-alert-top" :show="showDismissibleCountdown" variant="success" dismissible @dismissed="showDismissibleCountdown=0">
              <translate>Settings successfully updated!</translate>
            </b-alert>
            <b-alert :show="showDismissibleErrorCountdown" class="float-alert-top" variant="danger" dismissible @dismissed="showDismissibleErrorCountdown=0">
              <span v-for="[key, value] in Object.entries(errors)" :key="key">{{key}} - {{value[0]}}</span>
            </b-alert>
            <b-form-group id="input-group-19" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" label="" label-for="input-19">
                <GekkoButton 
                    :text="$gettext('Save Settings')" 
                    icon="fa-solid fa-floppy-disk"
                    type="submit"
                    class="position-relative"
                    :loading="isWaitingForResponse"
                />
            </b-form-group>
            <GekkoButton 
            :text="$gettext('Delete company')"
            icon="fa-solid fa-trash-can"
            variant="link"
            class="mr-2 text-danger"
            v-gk-confirm="{
                title: $gettext('Delete contact?'),
                message: $gettext('Are you sure you want to delete this contact?'),
                options: {
                    variant: 'danger',
                    confirmText: $gettext('Delete')
                },
                callback: destroy
            }" />
        </b-form>
    </div>
</template>

<script>
//todo: add this to the api
//if company.legal_form:
//      TrackEvents().set_people(request.user.email, {'legal_form': company.legal_form})


// @ is an alias to /src
import { mapGetters, mapMutations, mapActions } from "vuex";

import CompanyService from "@/store/services/company.service.js";
import AccountantsService from "@/store/services/accountants.service";
import CompanySettingService from "@/store/services/companysetting.service.js";
import GekkoButton from "@/components/GekkoButton";
import LogoModal from "@/components/logo_generator/LogoModal";
import CompanyLogo from "@/components/wizard/steps/CompanyLogo";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "CompanySettings",
    components: {
        GekkoButton,
        LogoModal,
        CompanyLogo
    },
    mixins: [settingsPageSetup],
    data() {
        return {
            showDismissibleCountdown: 0,
            showDismissibleErrorCountdown: 0,
            pageSettings: {
                title: this.$gettext("Change your company details"),
                showCompanyPicker: true
            },
            formChanged: false,
            form: {
                id: '',
                address: '',
                bank_account_number: '',
                bank_name: '',
                btw: '',
                btw_show_on_invoice: false,
                city: '',
                country: 'NL',
                show_country_on_invoice: '',
                administrative_area: '',
                description: '',
                email: '',
                kvk: '',
                legal_form: '',
                logo: null,
                name: '',
                phone_number: '',
                phone_number_show_on_invoice: false,
                postal_code: '',
                sector: '',
                coc_label: '',
                website: '',
                website_show_on_invoice: false,
                companysettings: {
                    id: '',
                    company: '',
                    show_swift_on_invoice: false,
                    swift_number: ''
                }
            },
            errors: {},
            entities: [],
            states: null,
            sectors: [],
            countries: [],
            imageSrc: '',
            accountantColor: "",
            showLogoModal: false
        }
    },
    computed: {
        ...mapGetters({
            currentCompany: 'main/getCurrentCompany',
            currentUser: "main/getCurrentUser",
            isWaitingForResponse: 'main/isWaitingForResponse'
        }),
        coc_label(){
            if(this.form.coc_label){
                return this.form.coc_label
            }
            return this.$gettext('KvK number')
        }
    },
    watch: {
        currentCompany(newVal) {
            if (this.currentUser.is_accountant)
                this.accountantColor = newVal.accountant_branding.color;
        }   
    },
    created(){
        CompanyService.getCurrent().then((response) => {
            var data = response.data;
            this.form = {
                id: data['id'],
                administrative_area: data['administrative_area'],
                address: data['address'],
                bank_account_number: data['bank_account_number'],
                bank_name: data['bank_name'],
                btw: data['btw'],
                btw_show_on_invoice: data['btw_show_on_invoice'],
                city: data['city'],
                country: data['country'],
                show_country_on_invoice: data['show_country_on_invoice'],
                description: data['description'],
                email: data['email'],
                kvk: data['kvk'],
                legal_form: data['legal_form'],
                name: data['name'],
                phone_number: data['phone_number'],
                phone_number_show_on_invoice: data['phone_number_show_on_invoice'],
                postal_code: data['postal_code'],
                sector: data['sector'],
                coc_label: data['coc_label'],
                website: data['website'],
                website_show_on_invoice: data['website_show_on_invoice'],
                companysettings: {
                    id: data.companysettings['id'],
                    company: data.companysettings['company'],
                    show_swift_on_invoice: data.companysettings['show_swift_on_invoice'],
                    swift_number: data.companysettings['swift_number']
                }
            };
            if(response.data.logo){
                this.imageSrc = response.data.logo;
            }
            CompanyService.getStates({country: this.form.country}).then((response) => {
              if (response.data.length === 0) {
                this.states = null;
              } else {
                this.states = response.data;
                this.states.unshift({key: '', value: '---------'});
              }
            })
        });
        CompanyService.getBusinessEntities().then((response) => {
            this.entities = response.data[this.form.country.toLowerCase()];
        });
        CompanyService.getSectors().then((response) => {
            this.sectors = response.data;
        });
        CompanyService.getCountries().then((response) => {
            this.countries = response.data;
        });
        
        if (this.currentUser.is_accountant)
            this.accountantColor = this.currentCompany.accountant_branding.color;
    },
    beforeRouteLeave (to, from , next) {
        if (this.formChanged) {
            const ConfirmModalConstructor = this.$options.components['confirm-modal']
            const confirmModalInstance = new ConfirmModalConstructor({ propsData: {
                title: this.$gettext('Leaving this page'),
                message: this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'),
                options: {
                    variant: 'primary',
                    confirmText: this.$gettext('Ok')
                }
            }})
            confirmModalInstance.$mount()
            document.body.appendChild(confirmModalInstance.$el)
            confirmModalInstance.$on('confirmed', () => {
                if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                    confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                }
                next()
            })
            confirmModalInstance.$on('cancel', () => {
                if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                    confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                }
            })
        } else {
            next()
        }
    },
    methods: {
        ...mapMutations({ 
            updateStoreCurrentCompany: 'main/SET_CURRENT_COMPANY',
            setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE'
        }),
        ...mapActions({ 
            switchCompany: 'main/switchCompanyProfile'
        }),
        onSubmit(evt) {
            evt.preventDefault();
            //create or edit
            this.setWaitingForResponse(true);
            if(this.form.logo === null){
                delete(this.form.logo);
            }
            if(this.form.id){
                let updated_company = {}
                let updated_companysettings = {}
                CompanyService.update(this.form).then((response) => {
                    updated_company = response.data
                    this.showDismissibleCountdown = 2
                    this.formChanged = false
                    CompanySettingService.update(this.form.companysettings).then((response) => {
                        updated_companysettings = response.data
                        updated_company.companysettings = updated_companysettings
                        this.updateStoreCurrentCompany(updated_company)
                    })
                }).catch(error => {
                  if (error.status === 400) {
                    this.showDismissibleErrorCountdown = 6
                    this.errors = error.data
                  }
                }).finally(() => {
                    this.setWaitingForResponse(false);
                })
            }

            if (this.currentUser.is_accountant) {
                let patchData = {
                    id: this.currentCompany.accountant_branding.id,
                    color: this.accountantColor
                }
                AccountantsService.updateAccountantProfile(this.currentCompany.accountant_branding.id, patchData);
            }
        },
        onFormChange(){
            this.formChanged = true;
        },
        destroy(){
            let id = this.form.id;
            CompanyService.destroy(id).then(() => {
                this.switchCompany(this.currentUser.default_company)
            }).catch((response) => {
                this.$store.commit('setAlert', {
                title: this.$gettext("Can't delete company"),
                text: this.$gettext(response.data.detail),
                variant: "error",
                duration: 4
                });
            });
        },
        beforeRouteLeave (to, from , next) {
            if (this.formChanged) {
                const ConfirmModalConstructor = this.$options.components['confirm-modal']
                const confirmModalInstance = new ConfirmModalConstructor({ propsData: {
                    title: this.$gettext('Leaving this page'),
                    message: this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'),
                    options: {
                        variant: 'primary',
                        confirmText: this.$gettext('Ok')
                    }
                }})
                confirmModalInstance.$mount()
                document.body.appendChild(confirmModalInstance.$el)
                confirmModalInstance.$on('confirmed', () => {
                    if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                        confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                    }
                    next()
                })
                confirmModalInstance.$on('cancel', () => {
                    if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                        confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                    }
                })
            } else {
                next()
            }
        },
        onLogoSet(companyObj) {
            var data = companyObj
            this.imageSrc = null

            this.form = {
                id: data['id'],
                administrative_area: data['administrative_area'],
                address: data['address'],
                bank_account_number: data['bank_account_number'],
                bank_name: data['bank_name'],
                btw: data['btw'],
                btw_show_on_invoice: data['btw_show_on_invoice'],
                city: data['city'],
                country: data['country'],
                description: data['description'],
                email: data['email'],
                kvk: data['kvk'],
                legal_form: data['legal_form'],
                name: data['name'],
                phone_number: data['phone_number'],
                phone_number_show_on_invoice: data['phone_number_show_on_invoice'],
                postal_code: data['postal_code'],
                sector: data['sector'],
                coc_label: data['coc_label'],
                companysettings: {
                    id: data.companysettings['id'],
                    company: data.companysettings['company'],
                    show_swift_on_invoice: data.companysettings['show_swift_on_invoice'],
                    swift_number: data.companysettings['swift_number']
                }
            }

            if(companyObj.logo) {
                this.imageSrc = companyObj.logo
            }
        },
        
    }
}
</script>

<style lang="scss">
.company-settings-logo {
    padding-top: 7px;
    .company-logo-gallery-wrap {
        padding-bottom: 1rem;
        .os-host {
            max-height: 350px;
        }
    }
}
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #0575ff;
    background-color: #0575ff;
}

.float-alert-top{
    position: fixed !important;
    top: 50px;
    right: 15%;
    z-index: 1000;
}

.branding-description-text {
    color: $colorTextSemi;
    font-style: italic;
}
</style>
